import DocumentoApi from "../api/DocumentoApi";

class DocumentoService {
    async buscarPecasFiltradas(idProcesso:number , idspecas: number[]){
        return DocumentoApi.buscarPecasFiltradas(idProcesso, idspecas);
    }
}

export default new DocumentoService();